import { render, staticRenderFns } from "./MerchantStatements.vue?vue&type=template&id=e2194122&scoped=true&"
import script from "./MerchantStatements.vue?vue&type=script&lang=js&"
export * from "./MerchantStatements.vue?vue&type=script&lang=js&"
import style0 from "./MerchantStatements.vue?vue&type=style&index=0&id=e2194122&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2194122",
  null
  
)

export default component.exports